import React from "react";
import useStyles from "../../partner/style";
import { TextField } from "@material-ui/core";

const InputDecimal = ({ text, setPartnerCode, type, label, name, placeholder, isEnable, isRequired, calculate }) => {
    const classes = useStyles();
    const onChange = (e) => {
        let start = e.target.selectionStart;
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;
        setPartnerCode({ ...text, text: value });
        if (val.length > 0) {
            e.target.value = Number(value).toFixed(2);
            e.target.setSelectionRange(start, start);
            setPartnerCode({ ...text, text: Number(value).toFixed(2) });
        }
    }
    const validateField = () => {
        if (text.text != '') {
            setPartnerCode({ ...text, valid: 'true' });
            calculate();
        } else {
            setPartnerCode({ ...text, valid: 'false' });
            calculate();
        }
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>
            <div style={{ display: "flex", justify: "center", alignItems: "center" }}>
                <p style={{ fontSize: "18px" }}>$</p>
                <TextField
                    InputProps={{
                        classes: {
                            focused: classes.textBorder,
                            input: classes.input,

                        },
                    }}
                    disabled={isEnable ?? false}
                    value={text.text}
                    onChange={onChange}
                    placeholder={placeholder}
                    type={type}
                    name={name}
                    onKeyUp={validateField.bind(this)}
                    onBlur={validateField.bind(this)}
                    style={{ width: '85%' }}
                    inputStyle={{ width: '85%' }}
                />
            </div>
        </div>
    );
}

export default InputDecimal;